import {
    get,
    post,
    importData
} from '@/utils/request'

const SERVICE_URL = '/mdata-service/v1'

export function deletePart(params, pathParam) {
    return get(SERVICE_URL + '/part/deletePart', params, pathParam)
}
export function queryById(params, pathParam) {
    return get(SERVICE_URL + '/part/getById', params, pathParam)
}
export function partList(params) {
    return post(SERVICE_URL + '/part/page', params)
}
export function createPart(params) {
    return post(SERVICE_URL + '/part/createPart', params)
}
export function editPart(params) {
    return post(SERVICE_URL + '/part/updatePart', params)
}
export function importFile(params) {
    return importData(SERVICE_URL + '/part/import', params)
}